import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PartnerIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="giới-thiệu-đối-tác" className="relative flex min-h-[70vh] w-full items-center justify-center overflow-hidden bg-[var(--background)] py-20">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/low_poly_construction_bg.png)] bg-cover bg-center bg-no-repeat opacity-40 mix-blend-multiply" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--background)]/80 via-[var(--background)]/60 to-[var(--background)]" />
      </div>

      {}
      <div ref={ref} className={`container relative z-10 mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <div className="mx-auto max-w-4xl space-y-8">
          {}
          <div className="inline-flex items-center rounded-full border border-[var(--ring)]/30 bg-[var(--ring)]/10 px-4 py-1.5 text-sm font-medium text-[var(--ring)] backdrop-blur-sm">
            <span className="mr-2 h-2 w-2 rounded-full bg-[var(--ring)] animate-pulse" />
            Strategic Collaboration
          </div>

          {}
          <h1 className="font-sans text-4xl font-bold tracking-tight text-[var(--foreground)] sm:text-5xl md:text-6xl lg:text-7xl">
            Pioneering Construction with{" "}
            <span className="block text-[var(--primary)] mt-2">
              Trusted Partners
            </span>
          </h1>

          {}
          <p className="mx-auto max-w-2xl text-lg text-[var(--muted-foreground)] md:text-xl leading-relaxed">
            NUCETECH collaborates with the National University of Civil Engineering and industry leaders to deliver cutting-edge technology transfer and digital transformation solutions.
          </p>

          {}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="bg-[var(--ring)] text-white hover:bg-[var(--ring)]/90 shadow-[var(--shadow-lg)] transition-all hover:-translate-y-1 px-8 py-6 text-lg rounded-none">
              <Link to="#contact">
                Partner with Us
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="border-[var(--primary)] text-[var(--primary)] hover:bg-[var(--primary)]/5 px-8 py-6 text-lg rounded-none">
              <Link to="/AboutUsPage">
                Learn More
              </Link>
            </Button>
          </div>
        </div>
      </div>
      
      {}
      <div className="absolute bottom-0 left-0 h-24 w-24 border-l-2 border-b-2 border-[var(--ring)]/20 opacity-50" />
      <div className="absolute top-0 right-0 h-24 w-24 border-r-2 border-t-2 border-[var(--ring)]/20 opacity-50" />
    </section>;
}